module.exports = __webpack_public_path__ + "img/ng.9eea84ef.svg";